import { Select } from '@any-ui-react/core';
import { DateUtils } from '@/common/utils';

const currentYear = new Date().getFullYear();

// Descending year options: from currentYear+2 down to AnyMind start year
export const YEAR_OPTIONS = Array.from(
  { length: currentYear + 2 - DateUtils.dateAnyMindStarts.getFullYear() + 1 },
  (_, i) => {
    const y = currentYear + 2 - i;
    return { value: String(y), label: String(y) };
  },
);

interface YearFilterProps {
  disabled?: boolean;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export const YearFilter = ({ disabled, placeholder, value, onChange }: YearFilterProps) => (
  <Select
    data={YEAR_OPTIONS}
    disabled={disabled}
    value={value}
    onChange={v => onChange(v ?? '')}
    className="w-28"
    placeholder={placeholder}
  />
);
